var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{staticClass:"d-md-down-none",on:{"click":_vm.newContact}},[_c('i',{staticClass:"fa fa-user-plus pr-2"}),_vm._v(" Ny kontakt ")])}
var staticRenderFns = []

export { render, staticRenderFns }